<template>
  <div class="viewport" ref="viewport">
    <div class="viewport--content" ref="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ScrollBooster from 'scrollbooster'

export default {
  name: 'Gallery',
  data () {
    return {
      sb: null
    }
  },
  mounted () {
    let viewport = this.$refs.viewport
    let content = this.$refs.content
    this.sb = new ScrollBooster({
      viewport: viewport,
      content: content,
      scrollMode: 'native',
      direction: 'horizontal'
    });
    // makes sure links (vue-link) in scroll area aren't triggered
    viewport.addEventListener('click', this.sb.events.click, true)
  },
  beforeDestroy () {
    this.sb.destroy()
  }
}
</script>

<style scoped>
.viewport {
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
}

.viewport::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background: transparent;
}

.viewport--content {
  white-space: nowrap;
}

.viewport--content > * {
  display: inline-block;
  vertical-align: top;
}
</style>